import {Stack} from '@mui/material';
import React, {Fragment} from 'react';

import {AppointmentBookingEnum} from 'main/analytics/gaTagsEnum';
import {useBookingStore} from 'presentation/modules/booking/shared/store/useBookingStore';
import {formatText, isSelectedSpecialty} from 'presentation/utils';
import {FlowEnum} from '../../constants';
import {SpecialtyCard} from '../SpecialtyCard';
import {StyledSpecialtiesGrid, StyledTypography} from './styles';
import {CategorizedSpecialtiesListProps} from './types';

export function CategorizedSpecialtiesList({
	list,
	handleSelectCard,
	flowType,
}: CategorizedSpecialtiesListProps) {
	const bookingData = useBookingStore(state => state.bookingData);
	const isExam = flowType === FlowEnum.EXAM;

	const dataTagId = isExam
		? AppointmentBookingEnum.SELECIONOU_EXAME
		: AppointmentBookingEnum.SELECIONOU_ESPECIALIDADE;

	return (
		<Fragment>
			{list.map(categoryItem =>
				categoryItem?.list?.length === 0 ? null : (
					<Stack key={categoryItem?.category} mt={2} gap={2}>
						<StyledTypography variant="h6" id={categoryItem?.category}>
							{categoryItem?.category}
						</StyledTypography>
						<StyledSpecialtiesGrid>
							{categoryItem?.list.map((item, index) => (
								<SpecialtyCard
									key={index}
									flowType={flowType}
									dataTagId={dataTagId}
									textDataTagId={
										!isExam
											? AppointmentBookingEnum.SELECIONOU_ESPECIALIDADE_TEXT
											: undefined
									}
									text={formatText(item?.formattedText)}
									handleClick={() => handleSelectCard(item)}
									selected={isSelectedSpecialty(
										item,
										bookingData?.specialtyCode,
										bookingData?.subSpecialtyCode,
									)}
									showSpecialtyDetailsButton={item.hasDefinition}
									specialtyCode={item.code}
								/>
							))}
						</StyledSpecialtiesGrid>
					</Stack>
				),
			)}
		</Fragment>
	);
}
